/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type NFLProjectionsTableQueryVariables = {|
  tzOffset: number
|};
export type NFLProjectionsTableQueryResponse = {|
  +nflGupProjections: ?$ReadOnlyArray<?{|
    +name: string,
    +position: string,
    +team: string,
    +opp: string,
    +homeAway: string,
    +pointSpread: any,
    +gameTotal: any,
    +impliedTt: any,
    +projPoints: any,
    +projOwnership: ?string,
    +salary: ?string,
    +percentDkSalary: ?string,
    +dkDollarValue: any,
    +slatePlayer: ?{|
      +id: string
    |},
  |}>,
  +lastNflGupProjectionUpdate: ?string,
|};
export type NFLProjectionsTableQuery = {|
  variables: NFLProjectionsTableQueryVariables,
  response: NFLProjectionsTableQueryResponse,
|};
*/


/*
query NFLProjectionsTableQuery(
  $tzOffset: Int!
) {
  nflGupProjections {
    name
    position
    team
    opp
    homeAway
    pointSpread
    gameTotal
    impliedTt
    projPoints
    projOwnership
    salary
    percentDkSalary
    dkDollarValue
    slatePlayer {
      id
    }
    id
  }
  lastNflGupProjectionUpdate(tzOffset: $tzOffset)
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tzOffset"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "team",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opp",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "homeAway",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pointSpread",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gameTotal",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "impliedTt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projPoints",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projOwnership",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salary",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentDkSalary",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dkDollarValue",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "SlatePlayerType",
  "kind": "LinkedField",
  "name": "slatePlayer",
  "plural": false,
  "selections": [
    (v14/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "tzOffset",
      "variableName": "tzOffset"
    }
  ],
  "kind": "ScalarField",
  "name": "lastNflGupProjectionUpdate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NFLProjectionsTableQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NFLGupProjectionsType",
        "kind": "LinkedField",
        "name": "nflGupProjections",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      (v16/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NFLProjectionsTableQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NFLGupProjectionsType",
        "kind": "LinkedField",
        "name": "nflGupProjections",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v15/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      (v16/*: any*/)
    ]
  },
  "params": {
    "cacheID": "90b9dcc6f49fa4e0a1170acd2a739359",
    "id": null,
    "metadata": {},
    "name": "NFLProjectionsTableQuery",
    "operationKind": "query",
    "text": "query NFLProjectionsTableQuery(\n  $tzOffset: Int!\n) {\n  nflGupProjections {\n    name\n    position\n    team\n    opp\n    homeAway\n    pointSpread\n    gameTotal\n    impliedTt\n    projPoints\n    projOwnership\n    salary\n    percentDkSalary\n    dkDollarValue\n    slatePlayer {\n      id\n    }\n    id\n  }\n  lastNflGupProjectionUpdate(tzOffset: $tzOffset)\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '076ab250cb7ffdc008541deb0bb71828';

module.exports = node;
